import { render, staticRenderFns } from "./fontloader.vue?vue&type=template&id=51d393ba"
import script from "./fontloader.vue?vue&type=script&setup=true&lang=js"
export * from "./fontloader.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports